export const version = {
	v: "3.3.5"
};
